// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alliedUnirversityCategoryViewStyles } from "@awc/App/Widgets/AlliedUniversityCategoryView/AlliedUniversityCategoryView";
import { FormFieldStyle } from "@awc/MobiusOverrides/FormField";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { boxSharedStyle, color, xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

alliedUnirversityCategoryViewStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 3fr;
        gap: 24px 16px;
        align-items: start;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

alliedUnirversityCategoryViewStyles.leftSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px 12px;
        ${boxSharedStyle({ variant: "secondary" })}
    `,
};

alliedUnirversityCategoryViewStyles.filtersContainer = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${FormFieldStyle} {
            display: grid;
            grid-template-columns: minmax(100px, 1fr) 2fr;
            justify-content: space-between;
        }
    `,
};

alliedUnirversityCategoryViewStyles.rightSection = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        ${boxSharedStyle({ variant: "secondary" })}
        &.au-list {
            color: ${color("common.ui29")};
        }
    `,
};

alliedUnirversityCategoryViewStyles.articlesContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, 1fr);
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(1, 1fr);
        }
    `,
};

alliedUnirversityCategoryViewStyles.articleContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        position: relative;
        height: 240px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

alliedUnirversityCategoryViewStyles.articleInfo = {
    css: css`
        position: absolute;
        bottom: 8px;
        right: 8px;
        left: 8px;
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};

alliedUnirversityCategoryViewStyles.articleTitle = {
    color: "common.ui14",
    typographyProps: {
        size: fontConfig.fontSize.singleLineRegular,
        css: css`
            line-height: ${fontConfig.lineHeight.singleLineRegular};
        `,
    },
    css: css`
        &&:hover ${TypographyStyle} {
            color: ${color("common.ui10")};
        }
        &&:hover ${TypographyStyle} {
            color: ${color("common.ui11")};
        }
    `,
};

alliedUnirversityCategoryViewStyles.articleQuickSummaryDisplay = {
    color: "common.white",
    css: css`
        margin-bottom: 16px;
    `,
};

alliedUnirversityCategoryViewStyles.articleDifficulty = {
    color: "common.white",
};

alliedUnirversityCategoryViewStyles.filterByArticleTypeText = {
    variant: "h3",
    forwardAs: "p",
};

alliedUnirversityCategoryViewStyles.resetFiltersButton = {
    variant: "tertiary",
    css: css`
        margin-top: 10px;
    `,
};
alliedUnirversityCategoryViewStyles.filterSelect = {
    mergeCss: true,
    labelProps: {
        mergeCss: true,
        color: "primary.main",
        css: css`
            text-align: left;
            &:after {
                content: ":";
                color: ${color("primary.main")};
            }
        `,
    }
};